import React, {PropTypes} from "react";
import {connect} from "react-redux";
import SearchForm from "./SearchForm";
import LinearProgress from "material-ui/LinearProgress";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";

let min = new Date();
min.setDate(min.getDate() - 2);
let max = new Date();
max.setDate(max.getDate() - 1);
let from = new Date();
from.setDate(from.getDate() - 7);
let to = new Date();
var default_search = {
  startDate: from,
  endDate: to
};

class LeaveTeamHistory extends React.Component {

  constructor() {
    super();
  }

  componentDidMount() {
    this.props.changeBanner("Team Leave History");
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 0;
    }
    else return cell;
  }


  render() {
    return (
      <div>
        <div role="tabpanel" className="tab-pane" id="apply">
          <div className="row clearfix">
            <h2 style={{marginTop: '5'}}>Team Leave History</h2>
            <SearchForm dates={default_search} isVertical={this.props.isVertical}/>
            {this.props.loading > 0 ?
              <LinearProgress mode="indeterminate" style={{margin: '2px', padding: '2px', width: '100%'}}/> :
              <label></label> }
            <div className="col-md-12"
                 style={{
                   borderBottomStyle: 'none',
                   marginBottom: '40px',
                   borderLeftStyle: 'solid',
                   marginTop: '0',
                   borderLeftColor: 'rgb(92, 184, 92)',
                   borderWidth: '1px',
                   borderBottomColor: '#008bcf',
                 }}
            >
              <BootstrapTable
                height="450"
                exportCSV={true}
                containerStyle={{paddingTop: 0}}
                data={this.props.teamHistory}>
                <TableHead dataSort={true}
                           isKey={true} width={130}
                           dataField="empId">Emp Id</TableHead>
                <TableHead dataSort={true}
                           filter={{type: "TextFilter", placeHolder: "Emp name"}}

                           width={110} dataField="empName">Employee Name</TableHead>
                <TableHead dataSort={true}
                           dataFormat={this.checkNull}
                           width={110}
                           dataField="el">Earned Leave</TableHead>
                <TableHead dataField="ol"
                           dataFormat={this.checkNull}
                           dataSort={true}
                           width={120}>Optional Leave</TableHead>
                <TableHead dataField="otherLeave"
                           dataFormat={this.checkNull}
                           dataSort={true}
                           width={120}>Other Leave</TableHead>
              </BootstrapTable>
            </div>
          </div>
        </div>
      </div>
    );
  }

}

LeaveTeamHistory.propTypes = {};

function mapStateToProps(state, ownState) {
  return {
    state: state,
    teamHistory: state.leave[4].teamHistory,
    loading: state.ajaxCallsInProgress
  };

}


export default connect(mapStateToProps)(LeaveTeamHistory);




/** WEBPACK FOOTER **
 ** ./src/feature/leave/LeaveTeamHistory.js
 **/